﻿
(function ($) {

	$.widget('lb.dropdown', {
		options: {
			list: '.ui-dropdown',
			delayIn: 250,
			delayOut: 850,
			offset: {
				top: 0,
				left: 0
			}
		},
		_hover: function() {
			var that = this;
			this.timerIn = setTimeout(function () {
				that.show();
			}, that.options.delayIn);
		},
		_create: function () {
			var that = this;
			var list = this.element.next(this.options.list);
			
			// Open menu when clicked
			this.element.bind('click', function (e) {
				if (!list.is(':visible')) {
					that.show();
				}
				e.preventDefault();
				e.stopPropagation();
			});
			this.element.parent().bind('mouseleave', function() {
				clearTimeout(that.timerIn);
				that.timerOut = setTimeout(function() {
					that.hide();
				}, that.options.delayOut);
			}).bind('mouseenter', function() {
				clearTimeout(that.timerOut);
				that._hover();
			});
			
			list.delegate('a', 'click', function() {
				that.hide();
			});

			// Click on body to close
			$('body').bind('mouseup', function (e) {
				if (!that.element.is(e.target)) {
					that.hide();
				}
			});
		},
		show: function (section) {
			var that = this;
			var list = this.element.next(this.options.list);
			list.css({
			  position: 'absolute',
			  left: this.element.position().left + this.options.offset.left,
			  top: this.element.position().top + this.element.outerHeight() + this.options.offset.top
			}).slideDown(this.options.speed, function () {
				that.element.trigger("dropdown.open");
			});
		},
		hide: function () {
			var list = this.element.next(this.options.list);
			list.slideUp(this.options.speed);
		}
	});

})(jQuery);
